import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import styled from '@emotion/styled';
import ResultList from '../../blocks/ResultList';
import BlankSlate from '../../blocks/BlankSlate';
import { Select } from '../../../atoms/Select';
import Button from '../../../atoms/buttons/Button';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Offer from '../Offers/Offer';
import SkeletonLoader from '../../../atoms/SkeletonLoader';
import Loader from '../../../atoms/LoaderStyled';
import { loadMoreButtonStyle } from '../../common/CommonStyle';
import { usePrevious } from '../../../utils/customHooks';

const ListItem = styled('ul')`
  list-style: none;
  margin: 0px;
  padding: 0px;
`;

const ButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '10px 0 30px 0',
});

interface CanceledOffersProps {
  offerType: any;
  refreshOfferType: any;
  isFetching: any;
  profile: any;
  checkProfile: any;
  loadRejectedMore: any;
  offers: any;
  moreExists: any;
}

const CanceledOffers = ({
  offerType,
  refreshOfferType,
  isFetching,
  profile,
  checkProfile,
  loadRejectedMore,
  offers,
  moreExists,
}: CanceledOffersProps): any => {
  const [orderingType, setOrderingType] = useState('recent');
  const [newOfferType, setNewOfferType] = useState('');
  const lastOfferType = usePrevious(newOfferType);

  useEffect(() => {
    if (newOfferType !== lastOfferType) {
      setNewOfferType(offerType);
      setOrderingType('recent');
    }
  }, [newOfferType, lastOfferType]);

  const renderOrderDropDown = () => {
    return (
      <Select
        onChange={changeOrder}
        value={orderingType}
        noSpacing
        style={{
          backgroundColor: '#F6F4F4',
        }}
        customSelectStyle={{
          color: orderingType ? 'inherit' : '#595959',
        }}
      >
        <option value="recent" key="new">
          Newest First
        </option>
        <option value="oldest" key="old">
          Oldest First
        </option>
        <option value="highest" key="high">
          Highest Price
        </option>
        <option value="lowest" key="low">
          Lowest Price
        </option>
      </Select>
    );
  };

  const changeOrder = e => {
    setOrderingType(e.target.value);
    refreshOfferType(e.target.value, true);
  };

  const offerList = (offers, noResults) => {
    const { offer_counts } = profile;
    const actionBtn = (
      <Button to="/search" buttonType="primaryRed">
        Find a date
      </Button>
    );

    if (offer_counts && !offer_counts.rejected)
      return <BlankSlate img={'offer'} title="No cancelled offers found" message={noResults.msg} action={actionBtn} />;

    if (isFetching && offers && offers.length <= 0)
      return (
        <ResultList>
          <Header bottomRuled panelHeader>
            <Headline size="SM">{`Canceled Offers (${offer_counts.rejected})`}</Headline>
          </Header>
          <ListItem>
            <SkeletonLoader width="100%" />
          </ListItem>
        </ResultList>
      );

    // loop through each mail item.
    if (!_.isEmpty(offers)) {
      const offerList = Object.keys(offers).map(key => {
        const offer = offers[key];
        const { id, hash_id, to_account_hash_id } = offer;

        return (
          <Offer
            key={`${id}_${hash_id}_${to_account_hash_id}`}
            offer={offer}
            profile={profile}
            checkProfile={checkProfile}
          />
        );
      });

      return (
        <div style={{ padding: 0 }}>
          <Header bottomRuled panelHeader>
            <Headline
              data-test-id="cancelled-offers-header"
              size="SM"
            >{`Canceled Offers (${offer_counts.rejected})`}</Headline>
            {renderOrderDropDown()}
          </Header>
          <ListItem>{offerList}</ListItem>
        </div>
      );
    } else {
      return <BlankSlate img={'offer'} title={noResults.title} message={noResults.msg} action={actionBtn} />;
    }
  };

  const { offer_counts } = profile;

  if (!offer_counts) return null;

  const subRoutes = [
    {
      page: `Rejected (${offer_counts.rejected})`,
      url: '/offers/rejected',
      active: '/.*rejected*/',
      noResultsTitle: 'No rejected Offers',
    },
  ];

  const noResults = {};

  subRoutes.map(function (route) {
    if (route.url === location.pathname) {
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      noResults.title = route.noResultsTitle;
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      noResults.msg = route.noResultsMsg;
      return route.page;
    } else {
      return null;
    }
  });

  return (
    <div>
      {offerList(offers, noResults)}
      {moreExists ? (
        <Loader active={isFetching} background={'transparent'}>
          <ButtonContainer>
            <Button
              buttonType="loadMore"
              onClick={() => {
                loadRejectedMore(orderingType);
              }}
              // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
              customStyle={loadMoreButtonStyle}
            >
              Load More...
            </Button>
          </ButtonContainer>
        </Loader>
      ) : null}
    </div>
  );
};

export default CanceledOffers;
